const ANDRE_EMAIL = 'andre.sandoval@easydebt.es';

export const canUseCalculator = (email, waGroups) => {
  const normalizedEmail = String(email || '').trim().toLowerCase();
  return normalizedEmail === ANDRE_EMAIL || (Array.isArray(waGroups) && waGroups.includes('operaciones'));
};
